"use client";

import { useEffect } from "react";
import { withSearchParams } from "../withSearchParams";
import { useAddVoucher, useToken } from "@frend-digital/centra/client";
import { sendGTMEvent, type GA4Event } from "@frend-digital/events/gtm";
import { useBeforeGtmEvent } from "@/app/_helpers/Events";

export const URLDiscount = withSearchParams(
	({ searchParams }) => {
		const addVoucher = useAddVoucher();
		const token = useToken();

		const beforeEvent = useBeforeGtmEvent();

		const discount = searchParams.get("discount");
		// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
		useEffect(() => {
			if (!token || !beforeEvent) return;

			if (discount) {
				addVoucher.mutate(
					{
						voucher: discount,
					},
					{
						onSuccess: async () => {
							searchParams.delete("discount");

							sendGTMEvent(
								await beforeEvent({
									// biome-ignore lint/suspicious/noExplicitAny: Type assertion required due to GA4Event type constraints; safe in this controlled context.
									event: "apply_coupon" as any,
									coupon: discount,
								} as unknown as GA4Event),
							);
						},
					},
				);
			}
		}, [discount, token, beforeEvent]);
		return null;
	},
	{ replace: true },
);
